import { ApiKey } from "src/modules/api/common/request/apiKey";
import { useCachedApi } from "src/modules/api/common/request/useCachedApi";
import { GetUserLazyDataResponse } from "./types";

export const useGetUserLazyData = () => {
  return useCachedApi<GetUserLazyDataResponse>({
    method: ApiKey.GET_USER_LAZY_DATA,
  });
};
